<script setup>
import {computed} from "vue";

const props = defineProps({
  tag: {
    type: Object,
    required: true
  },
  campaignTagIds: {
    type: Array,
    required: true
  },
  categoryName: {
    type: String,
    required: true
  },
  enableDelete: {
    type: Boolean,
    required: true
  },
  _siteUrl: {
    type: String,
    required: true
  },
  index: {
    type: Number,
    required: true
  }
});

const emits = defineEmits(['change-check', 'delete-tag']);

//このタグがキャンペーン投稿か否か
const checked = computed(() => props.campaignTagIds.some(tagId => Number(tagId) === Number(props.tag.id)));

/**
 * チェックの変更を親へ伝播
 * @param event
 */
const changeCheck = event => {
  emits('change-check', {
    check: ! checked.value,
    tagId: props.tag.id
  });
};

/**
 * タグの削除モーダルを表示
 */
const deleteTag = () => {
  emits('delete-tag', props.index);
};
</script>

<template>
  <li>
    <label
        class="pageTagLabel"
        @click="changeCheck"
    >
      <input
          :checked="checked"
          type="checkbox"
          disabled
      >
      <p class="pageTagBtn">{{categoryName}}<span class="dTag">{{tag.name}}</span></p>
    </label>
    <button
        v-if="enableDelete"
        type="button"
        class="pageTagDeleteBtn"
        @click="deleteTag"
    ><img
        :src="_siteUrl+'images/manager/tagDelete.png'"
        alt="削除"
    ></button>
  </li>
</template>
